// Admin i18n — content management (news feed, spotlight, settings).
const en = {
  "admin.cm.title": "Content Management",
  "admin.cm.subtitle": "News, platform updates and artist spotlights shown on artist dashboards",
  "admin.cm.tabContent": "Contents",
  "admin.cm.tabSpotlight": "Spotlight",
  "admin.cm.tabSettings": "Settings",
  "admin.cm.newContent": "New content",
  "admin.cm.newSpotlight": "New spotlight",
  "admin.cm.editItem": "Edit item",
  "admin.cm.refresh": "Refresh",
  "admin.cm.loadFailed": "Could not load contents",
  "admin.cm.retry": "Retry",
  "admin.cm.search": "Search by title…",
  "admin.cm.all": "All",
  "admin.cm.status.draft": "Draft",
  "admin.cm.status.published": "Published",
  "admin.cm.status.archived": "Archived",
  "admin.cm.type.news": "News",
  "admin.cm.type.dsp_update": "DSP update",
  "admin.cm.type.campaign": "Campaign",
  "admin.cm.type.tip": "Tip",
  "admin.cm.type.spotlight": "Spotlight",
  "admin.cm.featured": "Featured",
  "admin.cm.emptyContentTitle": "No content yet",
  "admin.cm.emptyContentDesc": "Create the first news item or update artists will see on their dashboard.",
  "admin.cm.emptyFilter": "No items match this filter.",
  "admin.cm.emptySpotlightTitle": "Spotlight is empty",
  "admin.cm.emptySpotlightDesc": "Feature an artist on every dashboard.",
  "admin.cm.created": "Item created",
  "admin.cm.updated": "Item updated",
  "admin.cm.saveFailed": "Save failed",
  "admin.cm.archiveConfirmTitle": "Archive this item?",
  "admin.cm.archiveConfirmDesc": "It will no longer be shown to artists. You can publish it again later.",
  "admin.cm.archive": "Archive",
  "admin.cm.archived": "Item archived",
  "admin.cm.archiveFailed": "Archive failed",
  "admin.cm.publish": "Publish",
  "admin.cm.published": "Published",
  "admin.cm.cancel": "Cancel",
  "admin.cm.create": "Create",
  "admin.cm.save": "Save",
  "admin.cm.f.title": "Title",
  "admin.cm.f.type": "Type",
  "admin.cm.f.status": "Status",
  "admin.cm.f.locale": "Audience language",
  "admin.cm.f.localeAll": "All languages",
  "admin.cm.f.image": "Image URL",
  "admin.cm.f.summary": "Short description",
  "admin.cm.f.body": "Body",
  "admin.cm.f.ctaText": "Button text",
  "admin.cm.f.ctaUrl": "Button link",
  "admin.cm.f.ctaUrlHint": "Starts with https:// or / (in-app path)",
  "admin.cm.f.featured": "Pin to top (featured)",
  "admin.cm.f.showOnOverview": "Show on dashboard",
  "admin.cm.f.artist": "Artist",
  "admin.cm.f.artistSearch": "Search artist by name or email…",
  "admin.cm.f.artistNone": "No artists found",
  "admin.cm.f.artistChange": "Change",
  "admin.cm.f.nameOverride": "Display name (optional)",
  "admin.cm.f.badge": "Badge text",
  "admin.cm.f.badgePh": "e.g. Artist of the week",
  "admin.cm.required": "Title is required",
  "admin.cm.artistRequired": "Pick an artist",
  "admin.cm.s.title": "Dashboard content settings",
  "admin.cm.s.spotlight": "Spotlight section",
  "admin.cm.s.spotlightDesc": "Show the artist spotlight on artist dashboards",
  "admin.cm.s.feed": "Content feed",
  "admin.cm.s.feedDesc": "Show news and updates on artist dashboards",
  "admin.cm.s.hideEmpty": "Hide empty sections",
  "admin.cm.s.hideEmptyDesc": "Don't render a section when it has nothing to show",
  "admin.cm.s.max": "Max spotlights on dashboard",
  "admin.cm.s.save": "Save settings",
  "admin.cm.s.saved": "Settings saved",
  "admin.cm.s.saveFailed": "Could not save settings",
};

const tr = {
  "admin.cm.title": "İçerik Yönetimi",
  "admin.cm.subtitle": "Sanatçı panolarında gösterilen haberler, platform güncellemeleri ve sanatçı vitrinleri",
  "admin.cm.tabContent": "İçerikler",
  "admin.cm.tabSpotlight": "Spotlight",
  "admin.cm.tabSettings": "Ayarlar",
  "admin.cm.newContent": "Yeni içerik",
  "admin.cm.newSpotlight": "Yeni spotlight",
  "admin.cm.editItem": "Öğeyi düzenle",
  "admin.cm.refresh": "Yenile",
  "admin.cm.loadFailed": "İçerikler yüklenemedi",
  "admin.cm.retry": "Tekrar dene",
  "admin.cm.search": "Başlığa göre ara…",
  "admin.cm.all": "Tümü",
  "admin.cm.status.draft": "Taslak",
  "admin.cm.status.published": "Yayında",
  "admin.cm.status.archived": "Arşiv",
  "admin.cm.type.news": "Haber",
  "admin.cm.type.dsp_update": "DSP güncellemesi",
  "admin.cm.type.campaign": "Kampanya",
  "admin.cm.type.tip": "İpucu",
  "admin.cm.type.spotlight": "Spotlight",
  "admin.cm.featured": "Öne çıkan",
  "admin.cm.emptyContentTitle": "Henüz içerik yok",
  "admin.cm.emptyContentDesc": "Sanatçıların panosunda görünecek ilk haberi veya güncellemeyi oluşturun.",
  "admin.cm.emptyFilter": "Bu filtreye uyan öğe yok.",
  "admin.cm.emptySpotlightTitle": "Spotlight boş",
  "admin.cm.emptySpotlightDesc": "Bir sanatçıyı tüm panolarda öne çıkarın.",
  "admin.cm.created": "Öğe oluşturuldu",
  "admin.cm.updated": "Öğe güncellendi",
  "admin.cm.saveFailed": "Kaydedilemedi",
  "admin.cm.archiveConfirmTitle": "Bu öğe arşivlensin mi?",
  "admin.cm.archiveConfirmDesc": "Artık sanatçılara gösterilmeyecek. Daha sonra tekrar yayınlayabilirsiniz.",
  "admin.cm.archive": "Arşivle",
  "admin.cm.archived": "Öğe arşivlendi",
  "admin.cm.archiveFailed": "Arşivlenemedi",
  "admin.cm.publish": "Yayınla",
  "admin.cm.published": "Yayınlandı",
  "admin.cm.cancel": "İptal",
  "admin.cm.create": "Oluştur",
  "admin.cm.save": "Kaydet",
  "admin.cm.f.title": "Başlık",
  "admin.cm.f.type": "Tür",
  "admin.cm.f.status": "Durum",
  "admin.cm.f.locale": "Hedef dil",
  "admin.cm.f.localeAll": "Tüm diller",
  "admin.cm.f.image": "Görsel URL",
  "admin.cm.f.summary": "Kısa açıklama",
  "admin.cm.f.body": "İçerik",
  "admin.cm.f.ctaText": "Buton metni",
  "admin.cm.f.ctaUrl": "Buton linki",
  "admin.cm.f.ctaUrlHint": "https:// veya / (uygulama içi yol) ile başlamalı",
  "admin.cm.f.featured": "En üste sabitle (öne çıkan)",
  "admin.cm.f.showOnOverview": "Panoda göster",
  "admin.cm.f.artist": "Sanatçı",
  "admin.cm.f.artistSearch": "İsim veya e-posta ile sanatçı ara…",
  "admin.cm.f.artistNone": "Sanatçı bulunamadı",
  "admin.cm.f.artistChange": "Değiştir",
  "admin.cm.f.nameOverride": "Görünen ad (opsiyonel)",
  "admin.cm.f.badge": "Rozet metni",
  "admin.cm.f.badgePh": "örn. Haftanın Sanatçısı",
  "admin.cm.required": "Başlık zorunlu",
  "admin.cm.artistRequired": "Bir sanatçı seçin",
  "admin.cm.s.title": "Pano içerik ayarları",
  "admin.cm.s.spotlight": "Spotlight bölümü",
  "admin.cm.s.spotlightDesc": "Sanatçı panolarında spotlight bölümünü göster",
  "admin.cm.s.feed": "İçerik akışı",
  "admin.cm.s.feedDesc": "Sanatçı panolarında haber ve güncellemeleri göster",
  "admin.cm.s.hideEmpty": "Boş bölümleri gizle",
  "admin.cm.s.hideEmptyDesc": "Gösterecek bir şey yoksa bölümü hiç çizme",
  "admin.cm.s.max": "Panoda maksimum spotlight",
  "admin.cm.s.save": "Ayarları kaydet",
  "admin.cm.s.saved": "Ayarlar kaydedildi",
  "admin.cm.s.saveFailed": "Ayarlar kaydedilemedi",
};

const es = {
  "admin.cm.title": "Gestión de contenido",
  "admin.cm.subtitle": "Noticias, novedades de plataforma y artistas destacados en los paneles de artistas",
  "admin.cm.tabContent": "Contenidos",
  "admin.cm.tabSpotlight": "Destacados",
  "admin.cm.tabSettings": "Ajustes",
  "admin.cm.newContent": "Nuevo contenido",
  "admin.cm.newSpotlight": "Nuevo destacado",
  "admin.cm.editItem": "Editar elemento",
  "admin.cm.refresh": "Actualizar",
  "admin.cm.loadFailed": "No se pudieron cargar los contenidos",
  "admin.cm.retry": "Reintentar",
  "admin.cm.search": "Buscar por título…",
  "admin.cm.all": "Todos",
  "admin.cm.status.draft": "Borrador",
  "admin.cm.status.published": "Publicado",
  "admin.cm.status.archived": "Archivado",
  "admin.cm.type.news": "Noticia",
  "admin.cm.type.dsp_update": "Novedad DSP",
  "admin.cm.type.campaign": "Campaña",
  "admin.cm.type.tip": "Consejo",
  "admin.cm.type.spotlight": "Destacado",
  "admin.cm.featured": "Fijado",
  "admin.cm.emptyContentTitle": "Aún no hay contenido",
  "admin.cm.emptyContentDesc": "Crea la primera noticia o novedad que verán los artistas en su panel.",
  "admin.cm.emptyFilter": "Ningún elemento coincide con este filtro.",
  "admin.cm.emptySpotlightTitle": "No hay destacados",
  "admin.cm.emptySpotlightDesc": "Destaca a un artista en todos los paneles.",
  "admin.cm.created": "Elemento creado",
  "admin.cm.updated": "Elemento actualizado",
  "admin.cm.saveFailed": "No se pudo guardar",
  "admin.cm.archiveConfirmTitle": "¿Archivar este elemento?",
  "admin.cm.archiveConfirmDesc": "Dejará de mostrarse a los artistas. Puedes publicarlo de nuevo más tarde.",
  "admin.cm.archive": "Archivar",
  "admin.cm.archived": "Elemento archivado",
  "admin.cm.archiveFailed": "No se pudo archivar",
  "admin.cm.publish": "Publicar",
  "admin.cm.published": "Publicado",
  "admin.cm.cancel": "Cancelar",
  "admin.cm.create": "Crear",
  "admin.cm.save": "Guardar",
  "admin.cm.f.title": "Título",
  "admin.cm.f.type": "Tipo",
  "admin.cm.f.status": "Estado",
  "admin.cm.f.locale": "Idioma del público",
  "admin.cm.f.localeAll": "Todos los idiomas",
  "admin.cm.f.image": "URL de imagen",
  "admin.cm.f.summary": "Descripción breve",
  "admin.cm.f.body": "Cuerpo",
  "admin.cm.f.ctaText": "Texto del botón",
  "admin.cm.f.ctaUrl": "Enlace del botón",
  "admin.cm.f.ctaUrlHint": "Empieza por https:// o / (ruta interna)",
  "admin.cm.f.featured": "Fijar arriba (destacado)",
  "admin.cm.f.showOnOverview": "Mostrar en el panel",
  "admin.cm.f.artist": "Artista",
  "admin.cm.f.artistSearch": "Buscar artista por nombre o email…",
  "admin.cm.f.artistNone": "No se encontraron artistas",
  "admin.cm.f.artistChange": "Cambiar",
  "admin.cm.f.nameOverride": "Nombre visible (opcional)",
  "admin.cm.f.badge": "Texto de la insignia",
  "admin.cm.f.badgePh": "p. ej. Artista de la semana",
  "admin.cm.required": "El título es obligatorio",
  "admin.cm.artistRequired": "Elige un artista",
  "admin.cm.s.title": "Ajustes de contenido del panel",
  "admin.cm.s.spotlight": "Sección de destacados",
  "admin.cm.s.spotlightDesc": "Mostrar el artista destacado en los paneles",
  "admin.cm.s.feed": "Feed de contenido",
  "admin.cm.s.feedDesc": "Mostrar noticias y novedades en los paneles",
  "admin.cm.s.hideEmpty": "Ocultar secciones vacías",
  "admin.cm.s.hideEmptyDesc": "No mostrar una sección si no tiene contenido",
  "admin.cm.s.max": "Máx. destacados en el panel",
  "admin.cm.s.save": "Guardar ajustes",
  "admin.cm.s.saved": "Ajustes guardados",
  "admin.cm.s.saveFailed": "No se pudieron guardar los ajustes",
};

export default { en, tr, es };
